import { defineMessages } from 'react-intl';

/**
 * The Plug voice (design outreach p1): Plug is the subject, one thing a sentence, a number when
 * Plug has one, the next step in the second sentence. "Plug" is a name: never translated. Pitch
 * emails, the pitch page and the stop page never name Plug.
 */
export const plugMessages = defineMessages({
  name: { id: 'app.outreach.plug.name', defaultMessage: 'Plug' },
  role: { id: 'app.outreach.plug.role', defaultMessage: 'Your pitch agent' },
  found: {
    id: 'app.outreach.plug.found',
    defaultMessage: 'Plug found {count, plural, one {# target} other {# targets}} for {song}.',
  },
  foundNoSong: {
    id: 'app.outreach.plug.foundNoSong',
    defaultMessage: 'Plug found {count, plural, one {# target} other {# targets}}.',
  },
  wrote: {
    id: 'app.outreach.plug.wrote',
    defaultMessage: 'Plug wrote {count, plural, one {# pitch} other {# pitches}}. Read them before they go.',
  },
  wroteSub: {
    id: 'app.outreach.plug.wroteSub',
    defaultMessage: 'Each one uses facts about the person. Nothing goes out until you approve it.',
  },
  wroteAutopilot: {
    id: 'app.outreach.plug.wroteAutopilot',
    defaultMessage: 'Plug wrote {count, plural, one {# pitch} other {# pitches}} and checked each one.',
  },
  wroteSubAutopilot: {
    id: 'app.outreach.plug.wroteSubAutopilot',
    defaultMessage:
      'Each one uses facts about the person. After you start, autopilot sends the ones that pass. The ones here did not pass: read them before they go.',
  },
  sorted: {
    id: 'app.outreach.plug.sorted',
    defaultMessage: 'Plug sorted {count, plural, one {# reply} other {# replies}}. {needs} need you.',
  },
  sortedSub: {
    id: 'app.outreach.plug.sortedSub',
    defaultMessage: 'Plug wrote an answer for each reply that needs one. You send it.',
  },
  autopilot: {
    id: 'app.outreach.plug.autopilot',
    defaultMessage: 'Plug is sending on autopilot: {sent} of {cap} today.',
  },
  working: { id: 'app.outreach.plug.working', defaultMessage: 'Plug is reading your playlists…' },
  workingWriting: {
    id: 'app.outreach.plug.workingWriting',
    defaultMessage: 'Plug is writing {count, plural, one {# pitch} other {# pitches}}…',
  },
  workingSub: {
    id: 'app.outreach.plug.workingSub',
    defaultMessage: 'About 20 seconds. You can leave this page. Plug tells you when it ends.',
  },
  failed: { id: 'app.outreach.plug.failed', defaultMessage: 'Plug could not finish. Try again.' },
  failedSub: { id: 'app.outreach.plug.failedSub', defaultMessage: 'Your profile did not change.' },
  needsEdit: {
    id: 'app.outreach.plug.needsEdit',
    defaultMessage: 'Plug could not write {count, plural, one {# pitch} other {# pitches}}.',
  },
  needsEditSub: {
    id: 'app.outreach.plug.needsEditSub',
    defaultMessage: 'The quality check stopped them. Write them yourself or skip them.',
  },
  suggests: { id: 'app.outreach.plug.suggests', defaultMessage: 'Plug suggests' },
  buildProfile: { id: 'app.outreach.plug.buildProfile', defaultMessage: 'Let Plug build my sound profile' },
  suggestedBy: { id: 'app.outreach.plug.suggestedBy', defaultMessage: 'Suggested by Plug' },
  writesInYourVoice: {
    id: 'app.outreach.plug.writesInYourVoice',
    defaultMessage: 'Plug writes in your voice. You read every pitch.',
  },

  // The home feed (frame p2). Events of the world keep the plain voice.
  feedProfileReady: { id: 'app.outreach.plug.feed.profileReady', defaultMessage: 'Plug built your sound profile' },
  feedTargetsFound: {
    id: 'app.outreach.plug.feed.targetsFound',
    defaultMessage: 'Plug found {count, plural, one {# target} other {# targets}}',
  },
  feedReply: { id: 'app.outreach.plug.feed.reply', defaultMessage: '{name} answered' },
  feedPlacement: { id: 'app.outreach.plug.feed.placement', defaultMessage: 'Placed on {name}' },
  feedCampaignDone: { id: 'app.outreach.plug.feed.campaignDone', defaultMessage: 'The campaign {name} ended' },
  feedEmpty: {
    id: 'app.outreach.plug.feed.empty',
    defaultMessage: 'Nothing new this week. Plug tells you here when a curator answers.',
  },

  // The autopilot chip (frame p4).
  autopilotOn: { id: 'app.outreach.plug.autopilot.on', defaultMessage: 'Autopilot on' },
  autopilotOnMeta: { id: 'app.outreach.plug.autopilot.onMeta', defaultMessage: '· {sent} of {cap} today' },
  autopilotPaused: { id: 'app.outreach.plug.autopilot.paused', defaultMessage: 'Autopilot paused' },
  autopilotSet: { id: 'app.outreach.plug.autopilot.set', defaultMessage: 'Autopilot set' },
  autopilotSetMeta: { id: 'app.outreach.plug.autopilot.setMeta', defaultMessage: '· sends after you start' },
  autopilotOff: { id: 'app.outreach.plug.autopilot.off', defaultMessage: 'Autopilot' },
  autopilotOffMeta: { id: 'app.outreach.plug.autopilot.offMeta', defaultMessage: '· on Plug' },
});
